import { Gradients } from "apparatus/gradients";
import { P, Pivot, R } from "apparatus/library/common";
import { Mounted } from "apparatus/library/physics/electric/mounted/utils";
import { Group, Path } from "paper";
/**
 * https://www.researchgate.net/figure/View-of-the-components-that-form-the-electric-motor-under-analysis_fig1_228893825
 */
export class Motor {
    render(appearance) {
        const { base, jacks, snaps } = Mounted.renderPlate({ appearance, width: 80, height: 50 });
        const motorBody = new Path.Rectangle(R(0, 0, 55, 32, Pivot.CENTER_RIGHT), 2.0)
            .withGradientFill("down", Gradients.cylinder("#444444".color()))
            .withStroke("default");
        const shaft = new Path.Rectangle(R(0, 0, 40, 4, Pivot.CENTER_LEFT), 2.0)
            .withGradientFill("down", Gradients.simple("#aaaaaa".color()))
            .withStroke("thinner");
        const gear = new Path.Rectangle(R(0, 0, 8, 10, Pivot.CENTER_LEFT), 2.0)
            .withGradientFill("down", Gradients.simple("#d0d0d0".color()))
            .withStroke("thinner");
        const leg1 = new Path.Rectangle(R(-5, 16, 12, 8, Pivot.CENTER_RIGHT), 2.0)
            .withGradientFill("up", Gradients.simple("#444444".color(), 10))
            .withStroke("thinner");
        const leg2 = new Path.Rectangle(R(-50, 16, 12, 8, Pivot.CENTER_LEFT), 2.0)
            .withGradientFill("up", Gradients.simple("#444444".color(), 10))
            .withStroke("thinner");
        const motor = new Group([shaft, gear, motorBody, leg1, leg2]);
        motor.pivot = P(0, 0);
        motor.withPosition({ x: 76, y: 10 });
        const graphic = new Group([base, jacks, motor]);
        return {
            graphic,
            hitShape: graphic.bounds.toShape(),
            pivot: base.bounds.center,
            snapping: [...snaps]
        };
    }
}
Motor.properties = {
    label: "Bulb",
    flippable: true,
    defaultAppearance: Object.assign({}, Mounted.defaultAppearance),
    appearanceSpecs: [
        ...Mounted.appearanceSpecs,
    ],
};
